import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { fetchAdmin, toErrorMessage } from '../../admin/api';
import { RequestState, StatCard, useAsyncState, AdminRouteLayout } from './AdminRoutePageShared';

export default function RiskPolicySummaryPage() {
  const summary = useAsyncState([]);

  useEffect(() => {
    const loadSummary = async () => {
      summary.setLoading();
      try {
        const response = await fetchAdmin('/risk/summary');
        summary.setData(response.summary || []);
      } catch (error) {
        summary.setError(toErrorMessage(error));
      }
    };

    loadSummary();
  }, []);

  return (
    <AdminRouteLayout title="Risk & Policy" breadcrumbTitle="Risk & Policy">
      <RequestState loading={summary.state.loading} error={summary.state.error}>
        <Grid container spacing={3}>
          {(summary.state.data || []).map((row) => (
            <Grid item xs={12} md={6} xl={4} key={row.decision_scope}>
              <StatCard title={row.decision_scope} value={row.total} caption={`${row.review_hits} review hits`} />
            </Grid>
          ))}
        </Grid>
      </RequestState>
    </AdminRouteLayout>
  );
}
